import { formEventV2 } from '@/service/formEventV2';

function getResource() {
  if (!!performance) {
    return performance?.getEntriesByType('resource');
  }
  return undefined;
}

function getJSFiles() {
  const resouce = getResource();
  if (!resouce) {
    return undefined;
  }
  return resouce.filter((item: any) => item?.initiatorType === 'script');
}

function getJSFilesFromName(name) {
  if (!name) {
    return undefined;
  }
  const jsFiles = getJSFiles();
  if (!jsFiles) {
    return undefined;
  }
  return jsFiles.filter((item) => item?.name?.includes(`${name}`));
}

function getJSFilesFromNames(names) {
  if (!names) {
    return undefined;
  }
  const jsFiles = getJSFiles();
  if (!jsFiles) {
    return undefined;
  }
  if (names instanceof Array) {
    return jsFiles.filter((item) => {
      for (let i = 0; i < names.length; i++) {
        const name = names[i];
        const res = item?.name?.includes(`${name}`);
        if (res) {
          return res;
        }
      }
      return false;
    });
  }
  return jsFiles.filter((item) => item?.name?.includes(`${names}`));
}

function getPageLoadTime() {
  if (!performance) {
    return undefined;
  }
  if (performance?.timing) {
    const pgLoadTime = performance.timing.responseStart - performance.timing.navigationStart;
    return pgLoadTime;
  }
  const navis = performance?.getEntriesByType('navigation');
  if (navis.length > 0) {
    return (navis[navis.length - 1] as any).responseStart;
  }
  return undefined;
}

function getFileRequestTime(name) {
  if (!name) {
    return undefined;
  }
  const configs = getJSFilesFromName(name);
  if (!configs || configs.length === 0) {
    return undefined;
  }
  const startTime = (configs[0] as any)?.fetchStart || (configs[0] as any)?.startTime;
  const pageLoadTime = getPageLoadTime();
  if (pageLoadTime > 0) {
    return `${startTime - pageLoadTime}`;
  }
  return `${startTime}`;
}

function getFilesRequestTime(names) {
  if (!names) {
    return undefined;
  }
  const configs: any = getJSFilesFromNames(names);
  if (!configs || configs.length === 0) {
    return undefined;
  }
  const startTime = configs[0]?.fetchStart || configs[0]?.startTime;
  const pageLoadTime = getPageLoadTime();
  if (pageLoadTime > 0 && startTime > pageLoadTime) {
    return `${startTime - pageLoadTime}`;
  }
  return `${startTime}`;
}

function getJsFileRequestTime(names) {
  if (names instanceof Array) {
    const time = getFilesRequestTime(names);
    if (time) {
      return `${parseInt(time)}`;
    }
  } else {
    const time = getFileRequestTime(names);
    if (time) {
      return `${parseInt(time)}`;
    }
  }
  return ``;
}

function cartseeJSNames() {
  return [
    `${'cart'}${'Animate'}${'.'}${'js'}`,
    `${'cart'}${'Animate'}${'Test'}${'.'}${'js'}`,
    `${'cart'}${'-animate'}${'-shopline'}${'.'}${'js'}`,
    `${'cart'}${'-animate'}${'-shopline'}${'-test'}${'.'}${'js'}`,
    `${'cart'}${'-animate'}${'-shoplazza'}${'.'}${'js'}`,
    `${'cart'}${'-animate'}${'-shoplazza'}${'-test'}${'.'}${'js'}`,
    `${'cart'}${'-animate'}${'-xike'}${'.'}${'js'}`,
    `${'cart'}${'-animate'}${'-xike'}${'-test'}${'.'}${'js'}`,
    `${'cart'}${'-animate'}${'-common'}${'.'}${'js'}`,
    `${'cart'}${'-animate'}${'-common'}${'-test'}${'.'}${'js'}`
  ];
}

const computeJSStart = (params) => {
  const aTime = getJsFileRequestTime(`${'stream'}${'-'}${'subscribe'}${'.'}${'js'}`);
  if (aTime && aTime.length > 0) {
    // 有则直接上报
    formEventV2(
      {
        ...params,
        event: 'stream_js_start',
        requestStart1: `${aTime}`,
        cliTimestamp: Date.now(),
        pathname: window.location.pathname
      }
    )
      .then((response) => {
        // console.log('数据上报成功')
      })
      .catch((e) => {});
  } else {
    // 添加监听
    const perf_observer = (list, observer) => {
      // Process the "measure" event
      // 处理 "measure" 事件
      const resouce = list.getEntries();
      const jsList = resouce.filter((item) => item?.initiatorType === 'script');
      // console.log('jsList', jsList);
      const configs = jsList.filter((item) => item?.name?.includes(`${'stream'}${'-'}${'subscribe'}${'.'}${'js'}`));
      // console.log('configs', configs);
      if (configs && configs.length > 0) {
        const startTime = configs[0]?.fetchStart || configs[0]?.startTime;
        let pageLoadTime = 0;
        if (performance?.timing) {
          const pgLoadTime = performance.timing.responseStart - performance.timing.navigationStart;
          pageLoadTime = pgLoadTime;
        } else {
          const navis = performance?.getEntriesByType('navigation');
          if (navis.length > 0) {
            pageLoadTime = (navis[navis.length - 1] as any).responseStart;
          }
        }
        let time = '';
        if (pageLoadTime > 0) {
          time = `${startTime - pageLoadTime}`;
        } else {
          time = `${startTime}`;
        }
        // console.log('time', time);
        formEventV2(
          {
            ...params,
            event: 'stream_js_start',
            requestStart1: `${time}`,
            cliTimestamp: Date.now(),
            pathname: window.location.pathname
          }
        )
          .then((response) => {
            // console.log('数据上报成功')
          })
          .catch((e) => {});
        try {
          observer.disconnect();
        } catch (error) {}
      }
    }
    try {
      var observer2 = new PerformanceObserver(perf_observer);
      observer2.observe({ entryTypes: ['resource'] });
    } catch (error) {}
  }
};

export { getJsFileRequestTime, cartseeJSNames, computeJSStart };
